module.exports = __webpack_public_path__ + "static/media/map-forecast-slider.084be3d3.png";